import { render, staticRenderFns } from "./product-category-modal.vue?vue&type=template&id=5cb71c3e&"
import script from "./product-category-modal.vue?vue&type=script&lang=js&"
export * from "./product-category-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports